<section class="linked-videos-section" *ngIf="videos.length > 0 || loading">
  <div class="section-header">
    <div>
      <p class="eyebrow">Related Content</p>
      <h2 class="section-title">Videos</h2>
    </div>
  </div>

  <!-- Loading -->
  <div class="videos-loading" *ngIf="loading">
    <div class="loader"></div>
    <p>Loading videos...</p>
  </div>

  <!-- Cards Row -->
  <div class="linked-scroll" *ngIf="!loading && videos.length > 0">
    <article
      *ngFor="let video of videos"
      class="linked-card"
      [class.active]="selectedVideo?.id === video.id"
      (click)="selectVideo(video)"
    >
      <div class="card-thumb">
        <img *ngIf="video.thumbnail_url" [src]="video.thumbnail_url" [alt]="video.title" />
        <div class="play-badge" *ngIf="!video.thumbnail_url">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" stroke="none">
            <polygon points="5 3 19 12 5 21 5 3" />
          </svg>
        </div>
        <span class="dur" *ngIf="video.duration_seconds">{{ formatDuration(video.duration_seconds) }}</span>
      </div>
      <div class="card-body">
        <h3>{{ text(video.title, 'Untitled') }}</h3>
        <span class="cat">{{ text(video.category, 'General') }}</span>
      </div>
    </article>
  </div>

  <!-- Featured Player -->
  <div class="featured" *ngIf="selectedVideo">
    <app-video-player
      [videoUrl]="text(selectedVideo.video_url)"
      [posterUrl]="text(selectedVideo.thumbnail_url)"
      [title]="text(selectedVideo.title)"
      [compact]="false"
    ></app-video-player>
    <div class="featured-info">
      <h3>{{ text(selectedVideo.title, 'Untitled') }}</h3>
      <p *ngIf="selectedVideo.description">{{ selectedVideo.description }}</p>
    </div>
  </div>
</section>
